import { useEffect, useState } from 'react';
import { useUserControllerUpdateMe } from '../../../api/informApi/informApiComponents';
import Popup from '../../../components/Popup';
import {
  Slides,
  SlidesOutlet,
  SlidesControl,
} from '../../../components/Slides';
import { useUserSession } from '../../../components/UserSession';
import Button from '../../../components/Button';
import WelcomeSlide from './WelcomeSlide';
import AboutSlide from './AboutSlide';
import styles from './Onboarding.module.scss';

const slides = [<WelcomeSlide />, <AboutSlide />];

function Onboarding() {
  const { mutateAsync } = useUserControllerUpdateMe();
  const { user, refetch, isAuthenticating } = useUserSession();
  const [show, setShow] = useState(false);
  const [active, setActive] = useState(0);

  useEffect(() => {
    if (isAuthenticating) return;
    const hasOnboarded = user?.userStatus.hasOnboarded ?? true;
    setShow(!hasOnboarded);
  }, [isAuthenticating, user]);

  const isEnd = active === slides.length - 1;
  const isStart = active === 0;

  const completeOnboarding = async () => {
    setShow(false);
    await mutateAsync({
      body: {
        userStatus: {
          hasOnboarded: true,
        },
      },
    });
    await refetch();
  };

  return (
    <Popup onClose={() => setShow(false)} show={show}>
      <div className={styles.container}>
        <Slides
          onSlideChange={(idx) => setActive(idx)}
          slides={slides}
          active={active}
        >
          <SlidesOutlet />
          <div className={styles.footer}>
            <Button
              onClick={
                isStart ? completeOnboarding : () => setActive(active - 1)
              }
              buttonColor="primary-1"
              variant="outline"
            >
              {isStart ? 'Skip' : 'Previous'}
            </Button>
            <SlidesControl />
            <Button
              onClick={isEnd ? completeOnboarding : () => setActive(active + 1)}
              buttonColor="primary-1"
              variant="solid"
            >
              {isEnd ? 'Start!' : 'Next'}
            </Button>
          </div>
        </Slides>
      </div>
    </Popup>
  );
}

export default Onboarding;
